export default {
  setDrawer({ commit }, payload) {
    commit("DRAWER", payload);
  },
  setExtendedSearch({ commit }, payload) {
    commit("EXTENDEDSEARCH", payload);
  },
  setDropdownDataAPI({ commit }, payload) {
    commit("DROPDOWNDATAAPI", payload);
  },
  setDeliveryDirectMailFlag({ commit }, payload) {
    commit("DeliveryDirectMailFlagActions", payload);
  },
  setPrintPublicationTypeBoxFlag({ commit }, payload) {
    commit("PrintPublicationTypeBoxFlag", payload);
  },
  setEmailElectronicTypeBoxFlag({ commit }, payload) {
    commit("EmailElectronicTypeBoxFlagActions", payload);
  },
  setsearchBtnFlag({ commit }, payload) {
    commit("rawsearchBtnFlagMut", payload);
  },
  setSocialNetworkNameBoxFlag({ commit }, payload) {
    commit("SocialNetworkNameBoxFlagActions", payload);
  },
  setofferOriginChangedAct({ commit }, payload) {
    commit("offerOriginMut", payload);
  },
  setBankingOptionBoxFlag({ commit }, payload) {
    commit("BankingOptionBoxFlagActions", payload);
  },
  setCreditOptionBoxFlag({ commit }, payload) {
    commit("CreditOptionBoxFlagActions", payload);
  },
  setAutomativeOptionBoxFlag({ commit }, payload) {
    commit("automativeOptionBoxFlagActions", payload);
  },
  setBankingSectorOptionBoxFlag({ commit }, payload) {
    commit("BankingSectorOptionBoxFlagActions", payload);
  },
  setCreditCardSectorBoxFlag({ commit }, payload) {
    commit("CreditCardSectorOptionBoxFlagActions", payload);
  },
  setUserSearchDate({ commit }, payload) {
    commit("UserSearchDateMut", payload);
  },
  setTime({ commit }, payload) {
    commit("TimeSelectionMut", payload);
  },
  setAffinityBoxesAction({ commit }, payload) {
    commit("affinityBoxesMut", payload);
  },
  setmediaAPIPayloadAction({ commit }, payload) {
    commit("mediaAPIPayloadMut", payload);
  },
  setsectorAPIPayloadAction({ commit }, payload) {
    commit("sectorAPIPayloadMut", payload);
  },
  setaudienceAPIPayloadAction({ commit }, payload) {
    commit("audienceAPIPayloadMut", payload);
  },
  setsearchResultAction({ commit }, payload) {
    commit("searchResultMut", payload);
  },
  setSearchAPIBodyAction({ commit }, payload) {
    commit("searchAPIBodyMut", payload);
  },
  setmonthSelectionPayloadStateAction({ commit }, payload) {
    commit("monthSelectionPayloadStateMut", payload);
  },
  setCompanyDataAction({ commit }, payload) {
    commit("CompanyDataMut", payload);
  },
  setAffinityDataAction({ commit }, payload) {
    commit("AffinityDataMut", payload);
  },
  setProductNamesDataAction({ commit }, payload) {
    commit("ProductNamesDataMut", payload);
  },
  setOldPageValueAction({ commit }, payload) {
    commit("OldPageValueMut", payload);
  },
  setocrFullTextPayloadAction({ commit }, payload) {
    commit("ocrFullTextPayloadMut", payload);
  },
  setSnackbarFlagAction({ commit }, payload) {
    commit("SnackbarFlagMut", payload);
  },
  settoMonthAction({ commit }, payload) {
    commit("toMonthMut", payload);
  },
  settoDateAction({ commit }, payload) {
    commit("toDateMut", payload);
  },
  settoYearAction({ commit }, payload) {
    commit("toYearMut", payload);
  },
  setfromYearAction({ commit }, payload) {
    commit("fromYearMut", payload);
  },
  setfromMonthAction({ commit }, payload) {
    commit("fromMonthMut", payload);
  },
  setfromDateAction({ commit }, payload) {
    commit("fromDateMut", payload);
  },
  setcommunicationTypeSelectionAction({ commit }, payload) {
    commit("communicationTypeSelectionMut", payload);
  },
  setDeliveryMethodPayloadAction({ commit }, payload) {
    commit("DeliveryMethodPayloadMut", payload);
  },
  setgroupSizePayloadPayloadAction({ commit }, payload) {
    commit("groupSizePayloadPayloadMut", payload);
  },
  setelectronicTypePayloadAction({ commit }, payload) {
    commit("electronicTypePayloadMut", payload);
  },
  setPublicationTypePayloadAction({ commit }, payload) {
    commit("PublicationTypePayloadMut", payload);
  },
  setproductCompaniesNamesAction({ commit }, payload) {
    commit("productCompaniesNamesMut", payload);
  },
  setpersonalizedRadiosAction({ commit }, payload) {
    commit("personalizedRadiosMut", payload);
  },
  setOldPaginationDataAction({ commit }, payload) {
    commit("OldPaginationDataMut", payload);
  },
  setPanelistTextAction({ commit }, payload) {
    commit("panelistTextMut", payload);
  },
  setPanelistRadioAction({ commit }, payload) {
    commit("panelistRadioMut", payload);
  },
  setissueTypePayloadAction({ commit }, payload) {
    commit("issueTypePayloadMut", payload);
  },
  setsocialPayloadAction({ commit }, payload) {
    commit("socialPayloadMut", payload);
  },
  setnetworkNamePayloadAction({ commit }, payload) {
    commit("networkNamePayloadMut", payload);
  },
  setintroductoryPricingPayloadAction({ commit }, payload) {
    commit("introductoryPricingPayloadMut", payload);
  },
  setSearchCriteriaMultiTextboxes({ commit }, payload) {
    commit("SearchCriteriaMultiTextboxes", payload);
  },
  setActionPayload({ commit }, payload) {
    commit("ActionPayload", payload);
  },
  setsearchDatePayloadAction({ commit }, payload) {
    commit("searchDatePayloadMut", payload);
  },
  setbetweenTimePayloadAction({ commit }, payload) {
    commit("betweenTimePayloadMut", payload);
  },
  setAndTimePayloadAction({ commit }, payload) {
    commit("AndTimePayloadMut", payload);
  },
  setPublicationNamePayloadAction({ commit }, payload) {
    commit("PublicationNamePayloadMut", payload);
  },
  setPublicationNameSelectedAction({ commit }, payload) {
    commit("PublicationNameSelectedMut", payload);
  },
  setsearchedBodyDataAction({ commit }, payload) {
    commit("searchedBodyDataMut", payload);
  },
  setsearchBtnDisabledFlagAction({ commit }, payload) {
    commit("searchBtnDisabledFlagMut", payload);
  },
  setsectorAllAction({ commit }, payload) {
    commit("sectorAllMut", payload);
  },
  setisAuthLogin({ commit }, payload) {
    commit("isAuthLoginMUT", payload);
  },
  setmediaAllAction({ commit }, payload) {
    commit("mediaAllMut", payload);
  },
  setaudienceAllAction({ commit }, payload) {
    commit("audienceAllMut", payload);
  },
  rawAdditionalAction({ commit }, payload) {
    commit("rawAdditionalMut", payload);
  },
  setSearchCritertia({ commit }, payload) {
    commit("SearchCritertiaMutation", payload);
  },
  setSearchSingleCritertia({ commit }, payload) {
    commit("SearchCritertiaSingleSelectMutation", payload);
  },
  previousPaginationFlagAction({ commit }, payload) {
    commit("previousPaginationFlagMut", payload);
  },
  nextPaginationFlagAction({ commit }, payload) {
    commit("nextPaginationFlagMut", payload);
  },
  lastPaginationFlagAction({ commit }, payload) {
    commit("lastPaginationFlagMut", payload);
  },
  lastPageNoAction({ commit }, payload) {
    commit("lastPageNoMut", payload);
  },
  searchResultOption({ commit }, payload) {
    commit("searchResultOptionMut", payload);
  },
  setLastResultFields({ commit }, payload) {
    commit("lastResultFieldsMut", payload);
  },
  setSearchAgainFlag({ commit }, payload) {
    commit("SearchAgainFlagMut", payload);
  },
  setOcrFullTextSearch({ commit }, payload) {
    commit("OcrFullTextSearchMut", payload);
  },
  setsearchDateSelection({ commit }, payload) {
    commit("searchDateSelectionMut", payload);
  },
  setUpdatedRawDataAction({ commit }, payload) {
    commit("UpdatedRawDataMut", payload);
  },
  setUserRawDataAction({ commit }, payload) {
    commit("UserRawDataMut", payload);
  },
  setsearchCriteriaGlobalAction({ commit }, payload) {
    commit("searchCriteriaGlobalMut", payload);
  },
  setmyexcelActivationAction({ commit }, payload) {
    commit("myexcelActivationMut", payload);
  },
};
